import { Resolver, ValidationMode } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { becomeDealerSchema } from "@/utils/validation/becomeDealerSchema";

export const dealerDefaultValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  email: "",
  streetAddress: "",
  city: "",
  zipCode: "",
  idCountry: 1,
  idState: 0,
  phoneNumber: "",
  username: "",
  password: "",
  confirmPassword: "",
  partnerOption: 1,
};
export const formConfig = {
  resolver: yupResolver(becomeDealerSchema) as Resolver<IBecomeDealerForm>,
  mode: "all" as keyof ValidationMode,
  defaultValues: dealerDefaultValues,
};
